import dayjs from 'dayjs';

import { isoDateOnlyFormat } from 'App/services/DateService';

function getInitialFormValueForQuestion(question) {
    if (question.type === 'date' && question.response) {
        const utcDate = dayjs.utc(question.response).format(isoDateOnlyFormat);
        return dayjs(utcDate, isoDateOnlyFormat).toDate();
    }
    if (question.type === 'select') {
        return question.answers[question.response];
    }
    if (question.type === 'multiselect') {
        return question.response?.map((responseId) => question.answers[responseId]);
    }
    return question.response;
}

function convertAssessmentQuestionToView(question) {
    return {
        ...question,
        response: getInitialFormValueForQuestion(question),
    };
}

export default convertAssessmentQuestionToView;
